import { ServerError } from '../interface_dto/ServerError';
export class ServerException {
  constructor(
    public readonly serverError: ServerError,
    public readonly url: string | undefined,
  ) {}

  public readonly exception: Error = new Error();
}
